import gql from 'graphql-tag';
import { lightUserFragment } from './light-user.fragment';
import { articleContentFragment } from './article-content.fragment';
import { engagementFragment } from './engagement.fragment';
import { CommentFragment } from './comment.fragment';
import { pageInfoFragment } from './page-info.fragment';
import { echoContentFragment } from './echo-content.fragment';
import { pollContentFragment } from './poll-content.fragment';
import { linkFragment } from './link.fragment';

export const postAndCommentsFragment = gql`
  fragment postAndCommentsFragment on Post {
    Id
    lastEdited
    body
    myVote
    postType

    myPollVote

    deleted

    links {
      ...linkFragment
    }
    images {
      ...linkFragment
    }

    videos {
      ...linkFragment
    }

    comments(limit: $commentLimit, after: $afterComment) {
      data {
        ...CommentFragment
      }
      pageInfo {
        ...pageInfoFragment
      }
    }

    articleContent {
      ...articleContentFragment
    }

    engagement {
      ...engagementFragment
    }

    echoContent {
      ...echoContentFragment
    }

    pollContent {
      ...pollContentFragment
    }

    author {
      ...lightUserFragment
    }
  }
  ${lightUserFragment}
  ${articleContentFragment}
  ${engagementFragment}
  ${CommentFragment}
  ${pageInfoFragment}
  ${echoContentFragment}
  ${pollContentFragment}
  ${linkFragment}
`;
